<ng-template #iconButton><ng-content select="[mat-icon-button]"></ng-content></ng-template>

<ng-template #innerLayout>
    <ng-container *ngIf="useInlineHeader">
        <ng-container *ngTemplateOutlet="iconButton"></ng-container>
    </ng-container>

    <span><ng-content></ng-content></span>

    <ng-container *ngIf="!(tabletMode$ | async)">
        <ng-content select="[mat-flat-button],[mat-fab]"></ng-content>
    </ng-container>
</ng-template>

<ng-template #defaultLayout>
    <h2 [class.inline-header]="useInlineHeader">
        <ng-container *ngTemplateOutlet="innerLayout"></ng-container>
    </h2>
</ng-template>

<ng-container *ngIf="!useInlineHeader">
    <ng-container *ngTemplateOutlet="iconButton"></ng-container>
    <button-spacer></button-spacer>
</ng-container>

<ng-container *ngIf="avatarHeader; else defaultLayout">
    <app-avatar-block [isLoadingInitialData]="loadingInitialData"
                      [svgIcon]="svg"
                      [initials]="initials">
        <h2 [class.inline-header]="useInlineHeader" avatarTitle>
            <ng-container *ngTemplateOutlet="innerLayout"></ng-container>
        </h2>
    </app-avatar-block>
</ng-container>
